<template>
  <div class="alert alert-warning outline oa-recovered-banner">
    <div class="d-flex align-items-start gap-2">
      <i class="fa fa-life-ring mt-1" aria-hidden="true"></i>
      <div class="flex-grow-1">
        <strong class="d-block mb-1">Recovered From A Request Odoo Refused</strong>
        <div class="oa-recovered-banner__lead">
          Odoo never created an invoice entry for this order because it rejected the most recent
          request. We recovered the data that was sent so you can correct it and send it again.
        </div>

        <ul v-if="recovery.validationErrors?.length" class="oa-recovered-banner__errors">
          <li v-for="(reason, i) in recovery.validationErrors" :key="i">{{ reason }}</li>
        </ul>
        <div v-else-if="recovery.errorMessage" class="oa-recovered-banner__errors">
          {{ recovery.errorMessage }}
        </div>

        <dl class="oa-recovered-banner__meta">
          <div v-if="recovery.attemptedAt">
            <dt>Attempted</dt>
            <dd>
              <ZonedDateTime
                :value="parsedAttemptedAt"
                :zone="userTimezone"
                kind="user"
                layout="inline"
              />
            </dd>
          </div>
          <div v-if="recovery.httpCode">
            <dt>Odoo Replied</dt>
            <dd>HTTP {{ recovery.httpCode }}</dd>
          </div>
          <div v-if="recovery.sourceLogId != null">
            <dt>Odoo Log</dt>
            <dd>#{{ recovery.sourceLogId }}</dd>
          </div>
        </dl>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { parseOdooDateTime } from '@/services/ryd-pay-operations/order-amendments/odoo-payment-recovery';
import ZonedDateTime from '@/components/common/ZonedDateTime.vue';
import { getUserAddDataFromLocalStorage } from '@/utils/userUtils';
import { resolveUserTimezone } from '@/utils/timezoneDisplay';

const props = defineProps({
  recovery: { type: Object, required: true },
});
const userTimezone = resolveUserTimezone((getUserAddDataFromLocalStorage() || {}).timezone);

// Odoo reports UTC without a zone marker, which reads as local time if shown raw.
const parsedAttemptedAt = computed(
  () => parseOdooDateTime(props.recovery.attemptedAt) || props.recovery.attemptedAt,
);
</script>

<style scoped>
.oa-recovered-banner {
  margin-bottom: 0;
}

.oa-recovered-banner__lead {
  color: var(--bs-body-color, #212529);
  font-size: 0.9rem;
  text-transform: none;
}

.oa-recovered-banner__errors {
  margin: 0.6rem 0 0 0;
  padding-left: 1.1rem;
  font-size: 0.88rem;
  color: var(--bs-body-color, #212529);
}

.oa-recovered-banner__errors li + li {
  margin-top: 0.25rem;
}

.oa-recovered-banner__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem 1.5rem;
  margin: 0.75rem 0 0 0;
  font-size: 0.82rem;
}

.oa-recovered-banner__meta > div {
  display: flex;
  gap: 0.4rem;
}

.oa-recovered-banner__meta dt {
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-size: 0.68rem;
  font-weight: 700;
  color: var(--bs-secondary-color, #6c757d);
  align-self: center;
}

.oa-recovered-banner__meta dd {
  margin: 0;
  color: var(--bs-body-color, #212529);
  font-weight: 500;
}
</style>
